<script>

    import {API, copyObj, terms$} from "../../lib/lib.js";
    import ScreenCenter from "../ScreenCenter.svelte";
    import PairEditor from "../varius/PairEditor.svelte";
    import ErrorDisplay from "../layout/ErrorDisplay.svelte";
    import Icon from "../layout/Icon.svelte";
    import TermItem from "./TermItem.svelte";

    let selectedTerm = null;
    let editorVisible = false;
    let errors = null;

    const closeEditor = () => editorVisible = false;

    const showEditor = ({detail: data}) => {
        data = data || {name:''};
        selectedTerm = copyObj(data);
        editorVisible = true;
    };

    const saveExtra = async () => {
        errors = '';
        selectedTerm.name = selectedTerm.name.trim();
        if (selectedTerm.name.length < 2) {
            errors = ['Πρέπει να δώσετε ένα σωστό τίτλο'];
            return;
        }

        const doEdit = async data => {
            const res = await API.patch(`term/${data.id}`, data);

            if (hasError(res.error)) {
                return;
            }

            terms$.update(store => {
                return store.map(ed => {
                    if (ed.id == data.id) {
                        ed.name = data.name;
                    }
                    return ed;
                });
            });

            showMessage('Αποθηκεύτηκε!');
            closeEditor();
        };

        const doAdd = async extraData => {
            const res = await API.post(`term`, extraData);
            if (hasError(res.error)) {
                return;
            }

            $terms$ = [...$terms$, res.data];
            showMessage('Αποθηκεύτηκε!');
            selectedTerm = null;
            editorVisible = false;
        };

        const hasError = arg => {
            if (arg == true) {
                errors = res.errors;
                showMessage('Κάποιο λάθος συνέβη');
                return true;
            }

            return false;
        };

        if (selectedTerm.id) {
            doEdit(selectedTerm);
        } else {
            doAdd(selectedTerm);
        }
    };
</script>


<div class="main-place">
    {#each $terms$ as data}
        <TermItem on:edit={showEditor} {data}/>
    {/each}

    <div class="p-sm bg-white flex items-center gap-sm justify-end">
        <button class="btn px-sm flex gap-2 text-sm" on:click={() => showEditor({})}>
            <Icon color="00aa00" icon="plus-circle"/>
            <span>Δημιουργία</span>
        </button>
    </div>
</div>


{#if editorVisible}
    <ScreenCenter title="{selectedTerm?.id ?  'Επεξεργασία' : 'Προσθήκη'}" on:close={closeEditor}>

        <PairEditor full title="Όνομα κατηγορίας">
            <input type="text" bind:value={selectedTerm.name}>
        </PairEditor>

        <ErrorDisplay bind:errors/>
        <hr>
        <div class="text-right">
            <button class="btn btn-link underline" on:click={closeEditor}>Κλείσιμο</button>
            <button class="btn btn-ok" on:click={saveExtra}>Αποθήκευση</button>
        </div>
    </ScreenCenter>
{/if}



